export default "__VITE_ASSET__KlkUMGkQ__"